/**
 * Northern Shopper — empty cart (clear every line from the cart page or drawer)
 */
(function () {
	"use strict";

	var NS = (window.NorthernShopper = window.NorthernShopper || {});
	var MODAL_ID = "ns-empty-cart-confirm";
	var FALLBACK_CART_EVENT_KEY = "northernShopperCartEvent";

	var clearing = false;
	var lastTrigger = null;

	function strings() {
		return (window.NorthernShopperStrings && window.NorthernShopperStrings.emptyCart) || {};
	}

	function t(key, fallback) {
		var value = strings()[key];
		return value == null || value === "" ? fallback : value;
	}

	function getRootUrl() {
		var root = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) || (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
		return root.endsWith("/") ? root : root + "/";
	}

	function cartUrl(path) {
		return getRootUrl() + path;
	}

	function toast(type, title) {
		if (NS.Toast) NS.Toast.show({ type: type, title: title });
	}

	function getModal() {
		return document.getElementById(MODAL_ID);
	}

	function isOpen() {
		var modal = getModal();
		return !!modal && !modal.hidden;
	}

	function openModal(trigger) {
		var modal = getModal();
		if (!modal) return;
		lastTrigger = trigger || null;
		modal.hidden = false;
		modal.setAttribute("aria-hidden", "false");
		document.body.classList.add("ns-custom-modal-open");
		var confirmBtn = modal.querySelector("[data-ns-empty-cart-confirm]");
		if (confirmBtn) confirmBtn.focus();
	}

	function closeModal() {
		var modal = getModal();
		if (!modal) return;
		if (modal.contains(document.activeElement) && document.activeElement.blur) {
			document.activeElement.blur();
		}
		modal.hidden = true;
		modal.setAttribute("aria-hidden", "true");
		if (!document.querySelector(".ns-custom-modal:not([hidden])")) {
			document.body.classList.remove("ns-custom-modal-open");
		}
		if (lastTrigger && document.contains(lastTrigger) && !lastTrigger.disabled) {
			lastTrigger.focus();
		}
		lastTrigger = null;
	}

	function setBusy(busy) {
		var modal = getModal();
		if (!modal) return;
		modal.querySelectorAll("button").forEach(function (button) {
			button.disabled = busy;
		});
		var confirmBtn = modal.querySelector("[data-ns-empty-cart-confirm]");
		if (confirmBtn) confirmBtn.classList.toggle("btn--loading", busy);
	}

	function hasCardQty() {
		return !!(NS.CardQty && typeof NS.CardQty.syncFromCart === "function");
	}

	/** Section ids the cart page / drawer want re-rendered, same as the theme's own cart calls. */
	function sectionsToBundle() {
		var sections = [];
		document.documentElement.dispatchEvent(
			new CustomEvent("cart:grouped-sections", {
				bubbles: true,
				detail: { sections: sections },
			}),
		);
		return sections;
	}

	function hasAllSections(cart, ids) {
		if (!cart || !cart.sections || !ids.length) return false;
		return ids.every(function (id) {
			return typeof cart.sections[id] === "string";
		});
	}

	function clearCart(sections) {
		return fetch(cartUrl("cart/clear.js"), {
			method: "POST",
			credentials: "same-origin",
			headers: { "Content-Type": "application/json", Accept: "application/json" },
			body: JSON.stringify({
				sections: sections,
				sections_url: window.location.pathname,
			}),
		}).then(function (response) {
			if (!response.ok) throw new Error("Unable to clear cart");
			return response.json();
		});
	}

	function broadcast(cart) {
		if (hasCardQty()) {
			NS.CardQty.syncFromCart(cart, true);
			return;
		}
		try {
			localStorage.setItem(FALLBACK_CART_EVENT_KEY, JSON.stringify({ ts: Date.now(), item_count: 0, items: [], trigger: null }));
		} catch (error) {
			/* ignore quota / private mode */
		}
	}

	function publishCart(cart) {
		if (window.FoxTheme && FoxTheme.pubsub) {
			FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
		}
		// Without section HTML the drawer only re-renders off `cart:refresh`. CardQty
		// fires that (plus the cart page refetch) for any sectionless cart update, so
		// only cover for it when it isn't loaded.
		if (!cart.sections && !hasCardQty()) {
			document.dispatchEvent(new CustomEvent("cart:refresh"));
		}
		if (NS.Pricing && typeof NS.Pricing.recalculateAll === "function") {
			NS.Pricing.recalculateAll();
		}
	}

	function emptyCart() {
		if (clearing) return Promise.resolve();
		clearing = true;
		setBusy(true);

		var ids = sectionsToBundle();

		return clearCart(ids)
			.then(function (cart) {
				// A partial `sections` object makes the theme's cart-items element tear
				// out #MainCart instead of re-rendering it, so drop it unless complete.
				if (!hasAllSections(cart, ids)) delete cart.sections;
				broadcast(cart);
				publishCart(cart);
				toast("success", t("emptied", "Cart emptied"));
			})
			.catch(function (error) {
				console.error("[NorthernShopper] Empty cart failed", error);
				toast("error", t("error", "We couldn’t empty your cart. Please try again."));
			})
			.finally(function () {
				clearing = false;
				setBusy(false);
				closeModal();
			});
	}

	function updateButtons(cart) {
		var count = cart && typeof cart.item_count === "number" ? cart.item_count : null;
		if (count === null) return;
		document.querySelectorAll("[data-ns-empty-cart]").forEach(function (button) {
			button.disabled = !count;
		});
	}

	function bindEvents() {
		// Delegated so the trigger survives the theme editor re-rendering either section.
		document.addEventListener("click", function (event) {
			var trigger = event.target.closest("[data-ns-empty-cart]");
			if (!trigger || trigger.disabled) return;
			event.preventDefault();
			openModal(trigger);
		});

		var modal = getModal();
		if (modal) {
			modal.querySelectorAll("[data-ns-empty-cart-cancel]").forEach(function (button) {
				button.addEventListener("click", function () {
					if (!clearing) closeModal();
				});
			});
			modal.querySelectorAll("[data-ns-empty-cart-confirm]").forEach(function (button) {
				button.addEventListener("click", emptyCart);
			});
			modal.addEventListener("click", function (event) {
				if (event.target === modal && !clearing) closeModal();
			});
		}

		document.addEventListener("keydown", function (event) {
			if (event.key === "Escape" && isOpen() && !clearing) closeModal();
		});

		if (window.FoxTheme && FoxTheme.pubsub) {
			FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
				updateButtons(event && event.cart);
			});
		}
	}

	NS.EmptyCart = {
		open: openModal,
		close: closeModal,
		empty: emptyCart,
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", bindEvents);
	} else {
		bindEvents();
	}
})();
